import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import { SextforceMetricsCountersLastOfEveryMonth } from './useSextforceMetricsCountersLastOfEveryMonth';

export type SextforceGroupsMetricsCountersLastOfEveryMonth = {
    summary: SextforceMetricsCountersLastOfEveryMonth[];
    metrics: {
        [key: string]: SextforceMetricsCountersLastOfEveryMonth[];
    };
};

const useSextforceMetricsGroupsCountersLastOfEveryMonth = (subscriberId: string | undefined | null, groupId: string | undefined | null) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchData = async (): Promise<SextforceGroupsMetricsCountersLastOfEveryMonth | null> => {
        const query: string = `${settingsContext.routes.metrics.base}${subscriberId}/groups/${groupId}/counters/lastOfMonth`;

        const data = await axios
            .get(query)
            .then(response => response.data)
            .catch(error => {
                console.error(error);

                return null;
            });

        return data;
    };

    return useQuery(['metricsGroupsCountersLastOfEveryMonth', subscriberId, groupId], () => fetchData(), {
        refetchOnWindowFocus: false,
        // 1 hour
        staleTime: 60 * 1000 * 60,
        enabled: userContext.jwtToken && settingsContext.apiKey && subscriberId && groupId ? true : false,
    });
};

export default useSextforceMetricsGroupsCountersLastOfEveryMonth;
